import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

/**
 * These helpers validate phone number *structure* only (valid country/length/format per
 * libphonenumber-js's metadata) — they do NOT check whether a number is mobile vs. landline.
 * The mobile check happens downstream: backend AWS Pinpoint validation and the SMS delivery itself.
 */

export const DEFAULT_COUNTRY = 'US';
/**
 * National digits typed by a user + selected country -> E.164 (or '' when unparseable).
 * A `+`-prefixed `national` value overrides the given `country`.
 */
export const toE164 = (country, national) => {
  const parsed = parsePhoneNumberFromString((national !== null && national !== void 0 ? national : '').trim(), country);
  return parsed && parsed.isValid() ? parsed.number : '';
};

/** E.164 -> country + national digits (no trunk prefix, no extension), for pre-filling the field. */
export const splitE164 = e164 => {
  var _parsed$country;
  const trimmed = (e164 !== null && e164 !== void 0 ? e164 : '').trim();
  const parsed = trimmed ? parsePhoneNumberFromString(trimmed) : undefined;
  if (!parsed) {
    return {
      country: DEFAULT_COUNTRY,
      national: ''
    };
  }
  return {
    country: (_parsed$country = parsed.country) !== null && _parsed$country !== void 0 ? _parsed$country : DEFAULT_COUNTRY,
    national: parsed.nationalNumber
  };
};

/** Exact E.164 only: a leading `+`, valid structure, no spaces/formatting/extension. */
export const isValidE164 = value => {
  const trimmed = (value !== null && value !== void 0 ? value : '').trim();
  if (!trimmed.startsWith('+')) return false;
  const parsed = parsePhoneNumberFromString(trimmed);
  if (!parsed) return false;
  return parsed.isValid() && parsed.number === trimmed;
};

/** '+16263692104' -> '+1 626 369 2104' */
export const formatPhoneForDisplay = e164 => {
  const trimmed = (e164 !== null && e164 !== void 0 ? e164 : '').trim();
  if (!trimmed) return '';
  const parsed = parsePhoneNumberFromString(trimmed);
  return parsed ? parsed.formatInternational() : trimmed;
};